<div class="grid" *ngIf="carInformacionInicial">
  <div class="col-12 md:col-12 lg:col-12 text-center">
    <i class="fa fa-refresh fa-spin fa-3x fa-fw"></i><br>
    <span>{{'LBL_CONSULTANDO' | translate }}</span>
  </div>
</div>
<div *ngIf="!carInformacionInicial">
  <p-accordion [multiple]="false" (onOpen)="abrirAcordeon($event)">
    <p-accordionTab header="{{ 'PREGUNTAS.LBL_NUEVAPREGUNTA' | translate}}" [selected]="tabSeleccionado === 'INFO'">
      <form [formGroup]="formulario" (ngSubmit)="onSubmit()">
        <div class="grid form-group">
          <div class="col-12 md:col-6 lg:col-6">
            <div class="div-form">
              <label for="codigop">* {{ 'LBL_CODIGO' | translate}}</label>
                <input type="text" id="codigop" name="codigop" pInputText formControlName="codigo"
                       maxlength="10"
                       (blur)="validarCodigo()" codigos-reactive/>
                <div class="p-message p-messages-error p-corner-all"
                     *ngIf="submitted && f.codigo.invalid">
                  <i class="fa fa-close"></i>{{ 'PREGUNTAS.MSG_CODREQUERIDO' | translate}}
                </div>
                <div class="p-message p-messages-error p-corner-all"
                     *ngIf="codExiste">
                  <i class="fa fa-close"></i>{{ 'PREGUNTAS.MSG_CODIGOEXISTE' | translate}}
                </div>
            </div>
          </div>


          <div class="col-12 md:col-6 lg:col-6" *ngIf="!pregunta">
            <div class="div-form">
              <label>* {{ 'PREGUNTAS.LBL_TIPO' | translate }}</label>
              <p-dropdown disableTab  id="idRol" name="nomRol" [options]="listaTiposPreguntas"
                          optionLabel="label" optionValue="value"
                          placeholder="{{ 'LBL_SELECCIONE' | translate}}"
                          filter="filter"
                          emptyFilterMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                           formControlName="idTipoPregunta"
              ></p-dropdown>
              <div class="p-message p-messages-error p-corner-all" *ngIf="submitted && f.idTipoPregunta.invalid">
                <i class="fa fa-close"></i>  {{ 'PREGUNTAS.LBL_TIPO' | translate}} {{ 'LBL_REQUERIDO' | translate}}
              </div>
            </div>
          </div>
          <div class="col-12 md:col-6 lg:col-6" *ngIf="pregunta && pregunta.idPregunta">
            <div class="div-form">
              <label>* {{ 'PREGUNTAS.LBL_TIPO' | translate }}</label>
              <label class="falso-combo-texto"><strong>{{pregunta.tipoPregunta}}</strong></label>
            </div>
          </div>
        </div>
        <div class="grid form-group">
          <div class="col-12 md:col-12 lg:col-12">
            <div class="div-form">
              <label for="formulacionpregunta">* {{ 'PREGUNTAS.LBL_FORMPREGUNTA' | translate}}</label>
              <textarea pInputTextarea id="formulacionpregunta" name="formulacionpregunta" formControlName="nombre"
                        maxlength="2000" capitalize-reactive></textarea>
              <div class="p-message p-messages-error p-corner-all" *ngIf="submitted && f.nombre.invalid">
                <i class="fa fa-close"></i> {{ 'PREGUNTAS.LBL_FORMPREGUNTA' | translate}} {{ 'LBL_REQUERIDO' | translate}}
              </div>
            </div>
          </div>
        </div>
        <div class="grid form-group">
          <div class="col-12 p-mg-6 lg:col-6">
            <div class="div-form">
              <p-checkbox binary="true" id="indicadorHabilitado" name="indicadorHabilitado"
                          label="{{ 'LBL_HABILITADO' | translate}}"
                          formControlName="indicadorHabilitado"></p-checkbox>
            </div>
          </div>
        </div>
        <div class="grid form-footer-buttons">
          <div class="form-group col-12" *ngIf="!guardando">
            <a (click)="goBack()" class="cancelar">{{ 'BTN_CANCELAR' | translate }}</a>
            <button pButton icon="fa fa-plus"
                    label="{{ ( pregunta && pregunta.idPregunta ? 'BTN_ACTUALIZAR' : 'BTN_GUARDAR') | translate}}"
                    type="submit"></button>
          </div>
          <div class="form-group col-12" *ngIf="guardando">
            <i class="fa fa-refresh fa-spin fa-fw"></i>
            <span>{{ 'LBL_GUARDANDO' | translate}}...</span>
          </div>
        </div>
      </form>
    </p-accordionTab>
    <p-accordionTab header="{{ 'PREGUNTAS.LBL_RESPUESTAS' | translate}}" *ngIf="mostrarSeccion"
                    [selected]="tabSeleccionado === 'PREG'">
      <form [formGroup]="heroForm" (ngSubmit)="onSubmitRespuestas()">
        <div formArrayName="pregunta" class="clearfix">
          <div *ngFor="let pregunt of controlesRespuestas.controls; let i=index">
            <div class="grid" *ngIf="i%2===0">
              <ng-container *ngFor="let iteracion of iterador; let ite=index">
                <div class="col-12 md:col-6 lg:col-6" *ngIf="controlesRespuestas.controls.length > (i + ite)" [formGroupName]="i + ite">
                  <p-card>
                    <div class="grid form-group">
                      <div class="col-11 md:col-11 lg:col-11">
                        <div class="div-form">
                          <label>* {{ 'LBL_CODIGO' | translate }}</label>
                            <input type="text" id="codigoR" name="codigoR" pInputText formControlName="codigo"
                                   (blur)="validarCodigoRespuestas(controlesRespuestas.controls[i + ite],i + ite)" codigos-reactive
                                   maxlength="10"/>
                            <div class="p-message p-messages-error p-corner-all"
                                 *ngIf="submittedR && controlesRespuestas.controls[i + ite].controls.codigo.invalid">
                              <i class="fa fa-close"></i>{{ 'PREGUNTAS.MSG_CODREQUERIDO' | translate}}
                            </div>
                            <div class="p-message p-messages-error p-corner-all"
                                 *ngIf="controlesRespuestas.controls[i + ite].controls.codigoExiste.value">
                              <i class="fa fa-close"></i>{{ 'PREGUNTAS.MSG_CODEXISTE' | translate}}
                            </div>
                        </div>
                      </div>
                      <div class="col-1 md:col-1 lg:col-1">
                        <a (click)="removerPregunta(controlesRespuestas.controls,controlesRespuestas.controls[i + ite],i + ite)"
                           *ngIf="(i + ite)!==0 && controlesRespuestas.controls[i + ite].controls.idRespuesta.value===null"
                           class="cancelar"><i class="fa fa-times"></i></a>
                      </div>
                    </div>
                    <div class="grid form-group">
                      <div class="col-11 md:col-11 lg:col-11">
                        <div class="div-form">
                          <label for="formulacionpregunta">* {{ 'PREGUNTAS.LBL_FORMRESPUESTA' | translate}}</label>
                          <div *ngIf="controlesRespuestas.controls[i + ite].controls.editando.value===false">
                          <textarea pInputTextarea id="respuesta" name="respuesta" formControlName="nombre"
                                    maxlength="250"></textarea>
                            <div class="p-message p-messages-error p-corner-all"
                                 *ngIf="submittedR && controlesRespuestas.controls[i + ite].controls.nombre.invalid">
                              <i class="fa fa-close"></i> {{ 'PREGUNTAS.LBL_FORMRESPUESTA' | translate}} {{ 'LBL_REQUERIDO' | translate}}
                            </div>
                          </div>
                          <div *ngIf="controlesRespuestas.controls[i + ite].controls.editando.value===true">
                            <label
                              class="falso-combo-texto"><strong>{{controlesRespuestas.controls[i + ite].controls.nombre.value}}</strong></label>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="grid form-group">
                      <div class="col-10 p-mg-10 lg:col-10">
                        <div class="div-form">
                          <p-checkbox binary="true" id="indicadorHabilitadoR" name="indicadorHabilitadoR"
                                      label="{{ 'LBL_HABILITADO' | translate}}"
                                      formControlName="indicadorHabilitado"></p-checkbox>
                        </div>
                      </div>
                    </div>
                  </p-card>
                </div>
              </ng-container>
            </div>
          </div>
        </div>
        <br>
        <div class="grid form-group">
          <div class="col-12 md:col-6 lg:col-6" *ngIf="!editandoR">
            <button pButton icon="fa fa-plus" label="{{ 'PREGUNTAS.BTN_NUEVARESPUESTA' | translate}}" type="button"
                    (click)="agregarPregunta(controlesRespuestas.controls)"></button>
          </div>
        </div>
        <div class="grid form-footer-buttons">
          <div class="form-group col-12" *ngIf="!guardandoP">
            <a (click)="goBackRespuestas()" class="cancelar">{{ 'BTN_CANCELAR' | translate }}</a>
            <button pButton icon="fa fa-plus" label="{{ 'BTN_GUARDAR' | translate}}" type="submit"></button>
          </div>
          <div class="form-group col-12" *ngIf="guardandoP">
            <i class="fa fa-refresh fa-spin fa-fw"></i>
            <span>{{ 'LBL_GUARDANDO' | translate}}...</span>
          </div>
        </div>
      </form>
    </p-accordionTab>
  </p-accordion>

</div>

<p-confirmDialog #cd>
  <ng-template pTemplate="footer">
    <button type="button" pButton icon="fa fa-close" label="{{ 'LBL_NO' | translate }}" (click)="cd.reject()"></button>
    <button type="button" pButton icon="fa fa-check" label="{{ 'LBL_SI' | translate }}" (click)="cd.accept()"></button>
  </ng-template>
</p-confirmDialog>
